import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DeniedDialogComponent } from './components/denied-dialog/denied-dialog.component';
import { SendDialogComponent } from './components/send-dialog/send-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    DeniedDialogComponent,
    SendDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    AlertDialogComponent,
    ConfirmDialogComponent,
    DeniedDialogComponent,
    SendDialogComponent
    
  ]
})
export class GlpCommonModule { }
